import { render, staticRenderFns } from "./hot-list.vue?vue&type=template&id=d1c71a34&scoped=true"
import script from "./hot-list.vue?vue&type=script&lang=js"
export * from "./hot-list.vue?vue&type=script&lang=js"
import style0 from "./hot-list.vue?vue&type=style&index=0&id=d1c71a34&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c71a34",
  null
  
)

export default component.exports